module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-regular-rounded-KDJ23353.woff?617b7e86cf6814a44b46708ded45349a";